/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_2_ResultInputs */

const et_portfolio_project_2_result = /** @type {(inputs: Portfolio_Project_2_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kvalifitseeritud päringud kasvasid 50% 3 kuu jooksul.`)
};

const en_portfolio_project_2_result = /** @type {(inputs: Portfolio_Project_2_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increased qualified inquiries by 50% within 3 months.`)
};

/**
* | output |
* | --- |
* | "Increased qualified inquiries by 50% within 3 months." |
*
* @param {Portfolio_Project_2_ResultInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_2_result = /** @type {((inputs?: Portfolio_Project_2_ResultInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_2_ResultInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_2_result(inputs)
	return en_portfolio_project_2_result(inputs)
});